import {
   Button,
   Flex,
   FlexProps,
   Heading,
   Image,
   ImageProps,
   LinkBox,
   LinkOverlay,
   Show,
   Text,
   useToken,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function openOption(url: Location | (string & Location)) {
   const isMobile = window.matchMedia('(max-width: 767px)').matches;

   if (isMobile) {
      window.location = url;
   }
}

const TileButton = ({ link, text }: any) => (
   <LinkOverlay
      as={Button}
      variant="cta"
      alignSelf="flex-end"
      marginTop={{ base: 4, sm: 6 }}
      minWidth={{ base: '150px', sm: '100%' }}
      onClick={() => {
         window.location.href = link;
      }}
   >
      {text}
   </LinkOverlay>
);

const OptionCard = ({ images, links, option }: any) => {
   // useToken is a hook to access theme tokens
   const [space2, space3, space5, space6, space7] = useToken('space', [2, 3, 5, 6, 7]);

   const Card: FlexProps = {
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      borderRadius: 'lg',
      color: 'gray.800',
      padding: { base: `${space3}`, md: `0 ${space5} ${space6}` },
      placeItems: 'center',
      borderWidth: '1px',
      borderColor: 'gray.300',
   };

   const CardImage: ImageProps = {
      htmlWidth: '250',
      htmlHeight: '160',
      minWidth: `calc(100% + (${space5} * 2))`,
      height: '215px',
      objectFit: 'cover',
   };

   const CardLayout: FlexProps = {
      flexDirection: { base: 'row', md: 'column' },
      flex: '1',
      // @ts-expect-error TS(2322) FIXME: Type '{ base: null; lg: "164px"; }' is not assigna... Remove this comment to see the full error message
      minHeight: { base: null, lg: '164px' },
   };

   const CardIconSize = '56px';

   const CardIcon = {
      overflow: 'hidden',
      width: CardIconSize,
      height: CardIconSize,
      margin: { base: `0 ${space3} ${space3} auto`, md: `-${space7} auto ${space6}` },
      flex: '0 0 auto',
      borderRadius: 'md',
      borderWidth: '1px',
      borderColor: 'brand.200',
      backgroundColor: 'brand.100',
      color: 'brand.500',
      alignItems: 'center',
      justifyContent: 'center',
   };

   const CardText: FlexProps = {
      height: '100%',
      flexDirection: 'column',
      flexGrow: '1',
      textAlign: { base: 'start', md: 'center' },
   };

   const OptionTitle = {
      fontWeight: 'medium',
      fontSize: '20px',
      margin: 0,
      color: 'gray.800',
   };

   const OptionDescription = {
      color: 'gray.600',
      margin: '0 auto',
      paddingTop: { base: `6px`, md: `${space2}` },
      flexGrow: 1,
   };

   return (
      <LinkBox as="div" {...Card} onClick={() => openOption(links[option.linkKey])}>
         <Show above="md">
            <Image
               {...CardImage}
               srcSet={`${images[option.imageIndex]['srcset']}_320.jpeg 320w, ${
                  images[option.imageIndex]['srcset']
               }_500.jpeg 500w`}
               src={images[option.imageIndex]['image']}
               alt={option.altText}
            />
         </Show>
         <Flex {...CardLayout}>
            <Flex {...CardIcon}>
               <FontAwesomeIcon icon={option.icon} size="lg" />
            </Flex>
            <Flex {...CardText}>
               <Heading as="h3" {...OptionTitle}>
                  {option.title}
               </Heading>
               <Text {...OptionDescription}>{option.description}</Text>
            </Flex>
         </Flex>
         <TileButton link={links[option.linkKey]} text={option.buttonText} />
      </LinkBox>
   );
};

export default OptionCard;
